// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  campId: __t.u64().primaryKey().name("camp_id"),
  owner: __t.identity(),
  worldId: __t.u64().name("world_id"),
  x: __t.f32(),
  y: __t.f32(),
  z: __t.f32(),
  yaw: __t.f32(),
  name: __t.string(),
  pitchedAt: __t.timestamp().name("pitched_at"),
  expiresAt: __t.timestamp().name("expires_at"),
});
